<template>
  <ResultCard
    :image-url="imageUrlToQuery"
    :num-uri-string="numUriString"
    :result="result"
  >
    <template v-slot:header>{{ result.method_display_name }}</template>
    <template v-slot:description>{{
      result.description || result.description_default
    }}</template>
    <template v-slot:detail>{{ formatResult(result) }}</template>
  </ResultCard>
</template>

<script>
import ResultCard from "@/views/Home/Card/Result";

export default {
  name: "ThirdPartyCard",
  props: {
    numUriString: String,
    result: Object,
  },
  components: {
    ResultCard,
  },
  computed: {
    imageUrlToQuery() {
      return this.result?.controller;
    },
  },
  methods: {
    formatResult(result) {
      return `${result?.value_prefix || ""}${result?.value?.display ||
        result?.value ||
        ""}`;
    },
  },
};
</script>
